export default __webpack_public_path__ + "static/media/our-commitment.f0330240.svg";